<template lang="pug">
  TicketList(:ticket="ticket" create=false title="Due Tickets")
</template>

<script>
import taskService from '../service.js'
import TicketList from './TicketList'
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      ticket: []
    }
  },
  components: {
    TicketList
  },
  computed: {
    ...mapGetters('global', ['currentUser'])
  },
  mounted() {
    this.getListOfUserDueTickets(this.currentUser.userID)
  },
  watch: {
    currentUser(val) {
      this.getListOfUserDueTickets(val.userID)
    },
  },
  methods: {
    getListOfUserDueTickets(id) {
      return taskService
      .getListOfUserDueTickets(id)
      .then((response) => {
        console.log('due ticket', response)
        this.ticket = response.data
      })
    },
  }
}
</script>

<style scoped>
</style>